<script setup lang="ts">
import { PButton } from '@pokerly/ui';
import { IconAlertTriangle, IconBulb } from '@tabler/icons-vue';
import { ref, computed } from 'vue';
import { useMockParticipants } from '@/dev-tools/index.js';

const { addParticipant, canAddMore, currentSessionRoom, participants, removeAll } = useMockParticipants();

const isLoading = ref(false);
const error = ref('');

const isButtonDisabled = computed(() => isLoading.value || !canAddMore.value);

function handleRemoveAll() {
    if (confirm('Remove all mock participants?')) {
        removeAll();
    }
}

async function handleAddParticipant() {
    if (isButtonDisabled.value) return;

    error.value = '';
    isLoading.value = true;

    try {
        await addParticipant();
    } catch (err) {
        error.value = err instanceof Error ? err.message : 'Failed to add participant';
        console.error('Error adding mock participant:', err);
    } finally {
        isLoading.value = false;
    }
}
</script>
<template>
    <div class="add-mock-participant-form">
        <div class="flex w-full gap-4">
            <PButton class="flex-1" @click="handleAddParticipant" :disabled="isLoading || !canAddMore">
                <span v-if="!isLoading">+ Add Participant</span>
                <span v-else>Adding...</span>
            </PButton>
            <PButton variant="destructive" class="flex-1" @click="handleRemoveAll" :disabled="participants.length == 0">
                Remove All
            </PButton>
        </div>
        <span v-if="!currentSessionRoom" class="paragraph-sm font-medium">
            <IconBulb /> Navigate to a session first to add mock participants
        </span>

        <span v-if="!canAddMore" class="paragraph-sm font-medium">
            <IconAlertTriangle /> Maximum mock participants (25) reached
        </span>

        <span v-if="error" class="paragraph-sm font-medium text-foreground-destructive">
            {{ error }}
        </span>
    </div>
</template>
